// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__wPhN_","selects":"Documents_selects__MWpp4"};